import * as React from 'react';
import { Route, RouteComponentProps } from 'react-router-dom';

import ListaDeProcesos from '../ListaDeProcesos';
import ProcesoDeMatricula from './ProcesoDeMatricula';

type Props = RouteComponentProps<{}>;

const Supervision: React.FunctionComponent<Props> = props => {
    const rutaBase = props.match.url;
    return (
        <div>
            <Route
                exact
                path={rutaBase}
                children={({ match }) => <ListaDeProcesos ocultar={!match} />}
            />
            <Route exact path={rutaBase + '/matriculas/:id'} component={ProcesoDeMatricula} />
        </div>
    );
};

export default Supervision;



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/Supervision/index.tsx